import ngLocale from "@angular/common/locales/en";
import { enUS as datefnsLocale } from "date-fns/locale";
import { LocaleBundle } from "@webapp/localization/models/localization.models";
import { locale as nzLocale } from "@webapp/ui/i18n/locales/en_US";

export const locale: LocaleBundle = { ngLocale, nzLocale, datefnsLocale };
